import urgent_level_color_map from "../../../../consts/urgent_level_color_map";

const getUrgentLevelColor = (urgent_level) => {

    return urgent_level===null? urgent_level_color_map.Default : urgent_level_color_map[urgent_level];
};

export default getUrgentLevelColor;
